import { createActionCreator } from 'deox';

export enum ExecutionDateActions {
	SET = '@EXECUTION_DATE_SET',
}

export const set = createActionCreator(
	ExecutionDateActions.SET, resolve => (date: string, update = true) => resolve({date, update}),
);
